import createReactComponent from '../createReactComponent';
var Archive = createReactComponent('Archive', [['polyline', {
  points: '21 8 21 21 3 21 3 8',
  key: '1084im'
}], ['rect', {
  x: '1',
  y: '3',
  width: '22',
  height: '5',
  key: '1vpa4z'
}], ['line', {
  x1: '10',
  y1: '12',
  x2: '14',
  y2: '12',
  key: '1aa9cx'
}]]);
export default Archive;